import React, { useState } from 'react'
import { Alert, Tooltip, OverlayTrigger } from "react-bootstrap";
import dp from '../../../images/img-default.svg'
import coin from '../../../images/projectCoinIcon.svg'
import * as Constants from "../../../constants/Constants";
import './ProjectItem.css'

const ProjectItem = ({
    title,
    author,
    amount,
    totalamount,
    endDate,
    overview,
    isDisabled = false,
    isEnded = false,
    isOpened = true,
    img
}) => {
    let projectImg = dp
    if (img !== undefined && img !== null && img !== "" && img !== "guid") {
        let imgUrl = Constants.BASE_URL + "/media/" + img + "/200" //first field: GUID, second is: size
        projectImg = imgUrl;
    }
    const addDefaultSrc = (ev) => {
        ev.target.src = dp;
    }

    const [showProjectAlert, setShowProjectAlert] = useState(false);
    const showProjectInfo = () => setShowProjectAlert(true);

    const projectInfoTooltip = (props) => (
        <Tooltip className="end_date-tooltip custom_tooltip" {...props}>
          Ends at 12 AM GMT (midnight)
        </Tooltip>
    );

    return (
        <div className='project-item'>
            <div className="project-info-container">
                <div className='project-title-section'>{title}</div>
                <div className="project-author-container">
                    <span className='project-author-section'>by  </span>
                    <span className='project-author-item'>{author}</span>
                </div>
                <div className='project-overview'>
                    {/* <div > */}{overview}{/* </div> */}
                </div>
                <div className='amount-rasied-section'>
                    <div className='raised-amount'>
                        {showProjectAlert && isEnded === true ? (
                            <Alert
                                variant="success"
                                className="project-alert"
                                onClose={() => setShowProjectAlert(false)}
                                dismissible
                            >
                                Ends at 12 AM GMT (midnight)
                            </Alert>
                        ) : ''}
                        <img src={coin} alt='' className='pitem-coin-icon' />
                        ${amount} raised <span className='of-amount'> of ${totalamount}</span>
                    </div>
                </div>
                <div className='enddate enddate-section'>
                    <div className='end-on-h'>End Date
                        <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={projectInfoTooltip}
                        >
                            <button
                                className={
                                    isOpened === true ? 
                                        'd-none' 
                                    : isDisabled === true ? 
                                        'info_icon_btn d-inline' 
                                    : isEnded === true ? 
                                        'info_icon_btn d-inline' 
                                    : ''
                                }
                                onClick={showProjectInfo}
                            ></button>
                        </OverlayTrigger>
                    </div>
                    <div className={isOpened === true ? 'enddate-active' : isDisabled === true ? 'enddate-active' : isEnded === true ? 'project-date-ended' : ''}>{endDate || "OPEN"}</div>
                </div>
            </div>
            <div className="project-image-container">
                <img
                    src={projectImg}
                    alt={title}
                    className='relative project-image-size img-object-fit-cover'
                    style={{ zIndex: '1', borderRadius: "4px" }}
                    onError={addDefaultSrc} />
                {
                    isEnded
                        ? <div className="project-has-ended-overlay text-align-center project-image-size project-overlay">
                            <div className="project-has-ended-overlay-text text-align-center mx-auto">
                                Ended
                            </div>
                        </div>
                        : isDisabled
                            ? <div className="project-disable-overlay text-align-center project-image-size project-overlay">
                                <div className="project-disable-overlay-text text-align-center mx-auto">
                                    Disabled
                                </div>
                            </div>
                            : null
                }

                <div className={isOpened === true ? 'enddate-section enddate-mobile ended_date-div' : 'enddate-section enddate-mobile'}>
                    <div className='end-on-h'>End Date
                        <div className={isOpened === true ? 'd-none' : isDisabled === true ? 'info-icon d-inline' : isEnded === true ? 'info-icon d-inline' : ''}>
                            <button className={isOpened === true ? 'd-none' : isDisabled === true ? 'info_icon_btn d-inline' : isEnded === true ? 'info_icon_btn d-inline' : ''}></button>
                        </div>
                    </div>
                    <div className={isOpened === true ? 'enddate-active' : isDisabled === true ? 'enddate-active' : isEnded === true ? 'project-date-ended' : ''}>{endDate || "OPEN"}</div>
                </div>
            </div>
        </div>
    )
}

export default ProjectItem;
